import { Button } from "antd";
import { useEffect, useState, type FC, type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../utils/translationUtils";
import { claimMfeStartupAutoReload } from "../utils/mfeStartupRecovery";
import { Loader } from "./Loader";

export const MFE_STARTUP_AUTO_RELOAD_DELAY_MS = 20_000;

interface MfeStartupFallbackProps {
  message: string;
  reloadPage?: () => void;
}

const reloadCurrentPage = (): void => {
  window.location.reload();
};

export const MfeStartupFallback: FC<MfeStartupFallbackProps> = ({
  message,
  reloadPage = reloadCurrentPage,
}): ReactElement => {
  const [timedOut, setTimedOut] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setTimedOut(true);
      if (claimMfeStartupAutoReload()) {
        reloadPage();
      }
    }, MFE_STARTUP_AUTO_RELOAD_DELAY_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [reloadPage]);

  if (timedOut) {
    return (
      <div className="error-boundary-container" role="alert">
        <h1 className="error-heading">
          {formatTranslation(t("errorBoundary.title"))}
        </h1>
        <p className="error-description">
          {formatTranslation(t("errorBoundary.description"))}
        </p>
        <Button className="error-retry-btn" size="large" onClick={reloadPage}>
          {formatTranslation(t("autozones.tryAgain"))}
        </Button>
      </div>
    );
  }

  return <Loader mask={true} message={message} />;
};
